import { API_BASE_URL } from "../config.js";

/**
 * Perform an authenticated GET request to the API.
 * Includes credentials so the session cookie is sent cross-origin.
 * An optional AbortSignal can be passed to cancel the request.
 */
export function apiGet(path: string, signal?: AbortSignal): Promise<Response> {
	return fetch(`${API_BASE_URL}${path}`, {
		method: "GET",
		credentials: "include",
		signal,
	});
}

/**
 * Perform an authenticated POST request to the API with a JSON body.
 * Includes credentials so the session cookie is sent cross-origin.
 */
export function apiPost(path: string, body: unknown): Promise<Response> {
	return fetch(`${API_BASE_URL}${path}`, {
		method: "POST",
		credentials: "include",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
}

/**
 * Perform an authenticated PATCH request to the API with a JSON body.
 * Includes credentials so the session cookie is sent cross-origin.
 */
export function apiPatch(path: string, body: unknown): Promise<Response> {
	return fetch(`${API_BASE_URL}${path}`, {
		method: "PATCH",
		credentials: "include",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
}

/**
 * Perform an authenticated PUT request to the API with a JSON body.
 * Includes credentials so the session cookie is sent cross-origin.
 */
export function apiPut(path: string, body: unknown): Promise<Response> {
	return fetch(`${API_BASE_URL}${path}`, {
		method: "PUT",
		credentials: "include",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
}

/**
 * Perform an authenticated DELETE request to the API.
 * Includes credentials so the session cookie is sent cross-origin.
 */
export function apiDelete(path: string): Promise<Response> {
	return fetch(`${API_BASE_URL}${path}`, {
		method: "DELETE",
		credentials: "include",
	});
}
